<template>
	<v-dialog
		v-model="showDialog"
		max-width="600px"
		@click:outside="showDialog = false"
		:fullscreen="$vuetify.breakpoint.xs ? true : false"
		:transition="$vuetify.breakpoint.xs ? 'scroll-y-reverse-transition' : ''"
	>
		<v-card>
			<v-toolbar dark color="primary" dense flat>
				<v-toolbar-title style="color: white">設計工数の変更</v-toolbar-title>
				<v-spacer />
				<v-btn icon dark @click="showDialog = false" color="white">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-toolbar>
			<!-- TODO 予実の製造番号検索時の問題でタブでの切り替えをやめる  -->
			<v-tabs v-model="tab">
				<v-tabs-slider color="primary"></v-tabs-slider>
				<v-tab v-for="(type, index) in types" :key="index">
					{{ type.name }}
				</v-tab>
			</v-tabs>
			<div class="mt-2 ml-2">※現在のページの情報のみ保存されます</div>
			<v-tabs-items v-model="tab">
				<v-tab-item v-for="(type, index) in types" :key="index">
					<div class="mt-4" v-if="tab == 0">
						<v-form class="px-2" ref="form" lazy-validation>
							<!--TODO 製品情報(製造番号など)非表示を検討  -->
							<v-row no-gutters class="mt-4">
								<v-col cols="12">
									<v-text-field
										type="text"
										v-model="searchWord"
										class="px-4"
										label="製造番号"
										outlined
										dense
										disabled
									/>
								</v-col>
							</v-row>
							<v-card class="mb-7 ml-4" max-width="320" v-if="selectedOrderedProduct">
								<v-card-text>
									<v-flex class="justify-space-between">
										<div>
											<p>製造番号：{{ selectedOrderedProduct.product_number }}</p>
											<p>製品名：{{ selectedOrderedProduct.product.name }}</p>
											<p>数量：{{ selectedOrderedProduct.quantity }}</p>
										</div>
									</v-flex>
								</v-card-text>
							</v-card>
							<v-row no-gutters class="mt-4">
								<v-col cols="6">
									<v-text-field
										v-model="planned_used_hours"
										class="px-4"
										outlined
										dense
										label="予定設計時間(単位:時間)"
										type="number"
										:rules="[rules.integer]"
										suffix="時間"
									></v-text-field>
								</v-col>

								<v-col cols="6">
									<v-select
										v-model="wage"
										:items="wageCosts"
										item-text="name"
										item-value="id"
										class="px-4"
										outlined
										dense
										label="設計者"
									></v-select>
								</v-col>
							</v-row>
						</v-form>
						<v-card-actions>
							<v-row no-gutters justify="center" class="pb-2">
								<v-btn
									:disabled="disabledBtn()"
									color="secondary"
									@click="updatePlannedDesignCost()"
									><v-icon class="mr-2">mdi-pencil</v-icon>編集する</v-btn
								>
							</v-row>
						</v-card-actions>
					</div>
					<div class="mt-4" v-if="tab == 1">
						<v-form class="px-2" ref="form" lazy-validation>
							<v-row no-gutters class="mt-4">
								<v-col cols="12">
									<v-text-field
										type="text"
										v-model="searchWord"
										class="px-4"
										label="製造番号"
										outlined
										dense
										disabled
									/>
								</v-col>
							</v-row>

							<v-card class="mb-7 ml-4" max-width="320" v-if="selectedOrderedProduct">
								<v-card-text>
									<v-flex class="justify-space-between">
										<div>
											<p>製造番号：{{ selectedOrderedProduct.product_number }}</p>
											<p>製品名：{{ selectedOrderedProduct.product.name }}</p>
											<p>数量：{{ selectedOrderedProduct.quantity }}</p>
										</div>
									</v-flex>
								</v-card-text>
							</v-card>
							<v-row no-gutters class="mt-4">
								<v-col cols="6">
									<v-text-field
										v-model="used_hours"
										class="px-4"
										outlined
										dense
										label="設計時間(単位:時間)"
										type="number"
										:rules="[rules.integer]"
										suffix="時間"
									></v-text-field>
								</v-col>

								<v-col cols="6">
									<v-select
										v-model="wage"
										:items="wageCosts"
										item-text="name"
										item-value="id"
										class="px-4"
										outlined
										dense
										label="設計者"
									></v-select>
								</v-col>
							</v-row>
						</v-form>
						<v-card-actions>
							<v-row no-gutters justify="center" class="pb-2">
								<v-btn :disabled="disabled()" color="secondary" @click="updateDesignCost()"
									><v-icon class="mr-2">mdi-pencil</v-icon>編集する</v-btn
								>
							</v-row>
						</v-card-actions>
					</div>
				</v-tab-item>
			</v-tabs-items>
		</v-card>
	</v-dialog>
</template>

<script>
import axios from "axios"
import authenticate from "../../../helper/authenticate"
import errorHandling from "../../../helper/errorHandling"
import rules from "../../../helper/rules"
import common from "../../../helper/common"

export default {
	components: {},
	props: {
		dialog: {
			type: Boolean,
			default: false,
		},
		orderedProduct: {
			type: null,
			required: false,
		},
		costCategory: {
			type: Object,
			required: false,
		},
	},
	data() {
		return {
			common: common,
			searchWord: null,
			rules: rules,
			cost: null,
			selectedOrderedProduct: null,
			used_hours: null,
			planned_used_hours: null,
			types: [{ name: "設計工数(予)" }, { name: "設計工数(実)" }],
			tab: null,
			wage: null,
			wageCosts: [],
		}
	},

	mounted() {
		this.tab = 0
		this.fetchWageNames()
	},

	methods: {
		orderedProductInfo(op) {
			return (
				"製造番号：" +
				op.product_number +
				"\n製品名　：" +
				op.product.name +
				"\n数量　　：" +
				op.quantity
			)
		},

		updateDesignCost() {
			this.$emit(
				"updateDesignCost",
				this.selectedOrderedProduct,
				this.used_hours,
				this.orderedProduct.man_hour.id,
				this.wage
			)
		},

		updatePlannedDesignCost() {
			this.$emit(
				"updatePlannedDesignCost",
				this.selectedOrderedProduct,
				this.planned_used_hours,
				this.orderedProduct.man_hour.id,
				this.wage
			)
		},

		fetchOrderedProductDesignCost(orderedProduct) {
			this.used_hours = orderedProduct.man_hour.used_hours
			this.planned_used_hours = orderedProduct.man_hour.planned_used_hours
			this.searchWord = orderedProduct.product_number
			this.wage = orderedProduct.man_hour.wage_cost
			this.selectedOrderedProduct = orderedProduct
		},
		disabled() {
			return this.selectedOrderedProduct == "" || this.used_hours == ""
		},

		disabledBtn() {
			return (
				this.planned_used_hours == 0 ||
				this.planned_used_hours == "" ||
				this.planned_used_hours == null ||
				this.wage == "" ||
				this.wage == null ||
				this.selectedOrderedProduct == "" ||
				this.selectedOrderedProduct == null
			)
		},

		fetchWageNames() {
			const headers = authenticate.setHeader()
			axios
				.get("/erp/v1/design_costs/design_costs/new", {
					headers,
				})
				.then((response) => {
					this.wageCosts = response.data.wage_costs
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
	},
	computed: {
		showDialog: {
			get() {
				return this.dialog
			},
			set(newVal) {
				return this.$emit("update:dialog", newVal)
			},
		},
	},
	watch: {
		orderedProduct(newValue) {
			this.fetchOrderedProductDesignCost(newValue)
		},
	},
}
</script>
